import { useEffect, useRef } from "react"
import rt from "aldoo-ra/Realtime"

/**
 * Subscribe to status updates for a project and/or component.
 * Fires `onUpdate(payload)` whenever a check belonging to the target finishes.
 */
export function useStatusUpdates({ projectId, componentId, onUpdate }) {
  const cbRef = useRef(onUpdate)
  useEffect(() => { cbRef.current = onUpdate }, [onUpdate])

  useEffect(() => {
    if (!projectId && !componentId) return
    let socket
    try {
      socket = rt("status")
    } catch (e) {
      // not authed yet
      return
    }

    const subscribe = () => {
      socket.emit("status:subscribe", { projectId, componentId })
    }
    const onUpdated = (payload) => {
      if (cbRef.current) cbRef.current(payload)
    }

    if (socket.connected) subscribe()
    socket.on("connect", subscribe)
    socket.on("status:check_updated", onUpdated)

    return () => {
      socket.off("connect", subscribe)
      socket.off("status:check_updated", onUpdated)
      socket.emit("status:unsubscribe", { projectId, componentId })
    }
  }, [projectId, componentId])
}
